<template>
  <v-row justify="center">
    <template v-if="!initialLoader">

      <v-app-bar v-if="isMobileDevice" height="55" :color="base.color_background" :dark="isDark" prominent>
        <v-app-bar-nav-icon @click.stop="drawer=!drawer"></v-app-bar-nav-icon>
      </v-app-bar>

      <v-navigation-drawer v-if="isMobileDevice || base.hosted_page_layout === 'vertical'" class="pa-6" v-model="drawer" :dark="isDark" :color="base.color_background" width="280px"
        :absolute="isMobileDevice"
        :temporary="isMobileDevice"
        :app="!isMobileDevice"
        :clipped="!isMobileDevice"
        :floating="!isMobileDevice"
        :permanent="!isMobileDevice"
        >
        <v-sheet class="mx-2 mt-2 overflow-hidden" width="100" light rounded outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="100">
              <v-img :src="base.logo_url" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
        <v-list class="mt-16" dense rounded>
          <v-list-item class="px-2" v-for="mi in base.menu_items" :key="mi.label" :href="mi.url" target="_blank" link>{{mi.label}}</v-list-item>
        </v-list>
        <template v-slot:append>
          <v-list dense rounded>
            <v-list-item class="px-2 body-2" v-if="base.terms_of_service_url" :href="base.terms_of_service_url" target="_blank" link>Términos de uso</v-list-item>
            <v-list-item class="px-2 body-2" v-if="base.privacy_policy_url" :href="base.privacy_policy_url" target="_blank" link>Política de privacidad</v-list-item>
          </v-list>
          <piriod-sign-variant class="px-2" align="center" :dark="isDark" />
        </template>
      </v-navigation-drawer>

      <v-app-bar v-if="!isMobileDevice && base.hosted_page_layout === 'horizontal'" :color="base.color_background" :dark="isDark" app elevate-on-scroll>
        <v-sheet class="overflow-hidden mt-14" width="100" light rounded outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="100">
              <v-img :src="base.logo_url" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
        <v-spacer />
        <v-btn class="ml-8" v-for="mi in base.menu_items" :key="mi.label" :href="mi.url" target="_blank" text link>{{mi.label}}</v-btn>
      </v-app-bar>

    </template>
    <v-col cols="12" class="pt-10 pb-0 text-center" style="max-width:900px;" v-if="!initialLoader && (base.hosted_page_title || base.hosted_page_description)">
      <span class="d-block text-h5 text--secondary font-weight-medium">{{base.hosted_page_title}}</span>
      <span class="d-block my-3">{{base.hosted_page_description}}</span>
    </v-col>
    <v-col cols="12" style="max-width:900px;">
      <div id="piriod-widget"></div>
    </v-col>
    <v-col cols="6" class="text-center" v-if="base.hosted_page_layout === 'horizontal'">
      <v-btn class="ml-4" v-if="base.terms_of_service_url" :href="base.terms_of_service_url" text>Términos de uso</v-btn>
      <v-btn class="ml-4" v-if="base.privacy_policy_url" :href="base.privacy_policy_url" text>Política de privacidad</v-btn>
      <piriod-sign-variant :dark="false" justify="center" />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import tinycolor from 'tinycolor2'

import GenericViewMixin from '@/mixins/GenericViewMixin'
import PiriodSignVariant from '@/components/PiriodSignVariant'

export default {
  name: 'hosted-customer-base',
  components: {
    PiriodSignVariant
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    drawer: false,
    initialLoader: false
  }),
  computed: {
    ...mapState({
      base: state => cloneDeep(state.hosted.basesDetail)
    }),
    isMobileDevice () {
      return this.$vuetify.breakpoint.width <= 600
    },
    isDark () {
      if (!this.base.color_background) {
        return false
      }
      const tc = tinycolor(this.base.color_background)
      if (tc) {
        return tc.isDark()
      }
      return false
    }
  },
  mounted () {
    window.piriodSettings = {
      service: 'customerBase',
      customerBaseId: this.$route.params.publishableKey
    }

    if (this.$route.name === 'HostedCustomerBase') {
      window.piriodSettings.sessionKey = this.$route.params.sessionKey
    }

    this.installPiriodWidget()
  },
  created () {
    this.initialLoader = true

    this.$store.dispatch('hosted/RETRIEVE', {
      resource: 'publishable/customer_base/bases',
      id: this.$route.params.publishableKey
    })
    .then(() => {
      if (!this.base.enable_hosted) {
        this.$router.push({ name: 'PageExpired' })
      }
    })
    .catch((error) => {
      if (error.response.status === 404) {
        this.$router.push({ name: 'PageExpired' })
      }
    })
    .finally(() => {
      setTimeout(() => {
        this.initialLoader = false
      }, 500)
    })
  },
  methods: {
    installPiriodWidget () {
      const s = document.createElement('script')

      s.src = this.$JS_BASE + '/embed/piriod-embed.umd.min.js'
      s.async = true
      s.type = 'text/javascript'

      const x = document.getElementsByTagName('script')[0]

      x.parentNode.insertBefore(s, x)
    }
  }
}
</script>
<style>
  .v-toolbar__content {
    margin: 0 auto !important;
    max-width: 860px !important;
  }
</style>